import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Section = styled.section`
    padding: 80px 20px;
    background: #fff;
    text-align: center;
`;

const Title = styled.h2`
    color: #007bff;
    margin-bottom: 2rem;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    justify-items: center;
`;

const Card = styled.div`
    background: #f5f5f5;
    border-radius: 16px;
    padding: 20px;
    max-width: 350px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
`;

const Image = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 1rem;
`;

const Name = styled.h4`
  margin-bottom: 0.5rem;
`;

const Text = styled.p`
  font-size: 0.95rem;
`;

export const Testimonials: React.FC = () => {
    const { t } = useTranslation();

    const testimonials = [
        { name: "Sofia", text: t("testimonials.1"), img: "https://randomuser.me/api/portraits/women/1.jpg" },
        { name: "Lucas", text: t("testimonials.2"), img: "https://randomuser.me/api/portraits/men/2.jpg" },
        { name: "Camila", text: t("testimonials.3"), img: "https://randomuser.me/api/portraits/women/3.jpg" },
    ];

    return (
        <Section id="stories">
            <Title>{t("testimonials.title")}</Title>
            <Grid>
                {testimonials.map((t, i) => (
                    <Card key={i}>
                        <Image src={t.img} alt={t.name} />
                        <Name>{t.name}</Name>
                        <Text>{t.text}</Text>
                    </Card>
                ))}
            </Grid>
        </Section>
    );
};
